/**
 * Shared CSRF token extraction.
 * Reads the anti-forgery token from the page's hidden input or a specific form.
 */

/**
 * Get the CSRF token value from an anti-forgery hidden input.
 * @param {HTMLFormElement|Document} [scope=document] — element to search within.
 * @returns {string} token value, or empty string if not found.
 */
export function getCsrfToken(scope) {
  var root = scope || document;
  var input = root.querySelector('input[name="__RequestVerificationToken"]');
  return input ? input.value : "";
}

/**
 * Build a headers object that includes the CSRF token (if available)
 * merged with any extra headers.
 * @param {Object} [extra] — additional headers to merge.
 * @returns {Object} headers object suitable for fetch().
 */
export function csrfHeaders(extra) {
  var hdrs = Object.assign({ "Content-Type": "application/json" }, extra || {});
  var token = getCsrfToken();
  if (token) hdrs["X-CSRF-TOKEN"] = token;
  return hdrs;
}
